import React from 'react';
import PropTypes from 'prop-types';

import { Floating } from './FloatingText.styled';

const FloatingText = ({ text, dark, invert, horizontal, style }) => (
  <Floating dark={dark} invert={invert} horizontal={horizontal} style={style}>
    <p>
      {text}
      <span />
    </p>
  </Floating>
);

FloatingText.propTypes = {
  text: PropTypes.string.isRequired,
  dark: PropTypes.bool,
  invert: PropTypes.bool,
  horizontal: PropTypes.bool,
  style: PropTypes.object,
};

export default FloatingText;
